import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'leaveType', headerName: 'Leave Type', width: 130 },
  {
    field: 'fromDate',
    headerName: 'From Date',
    type: 'Date',
    width: 130
  },
  { field: 'toDate', headerName: 'To Date', width: 130 },
  { field: 'leaveReason', headerName: 'Reason For Leave', width: 130 },
  {
    field: 'totalDays',
    headerName: 'Total Days',
    type: 'number',
    width: 130
  },
  {
    field: 'isHalfDayLeave',
    headerName: 'Half Day',
    type: Boolean,
    width: 130
  },
  {
    field: 'leaveDate',
    headerName: 'Date of Leave',
    type: Date,
    width: 130
  },

];

const rows = [
  { id: 1, leaveType: 'Medical', fromDate: new Date(), toDate: '35', leaveReason: 'XYZ', totalDays: 2, isHalfDayLeave: false, leaveDate: new Date()},
];

export default function LeaveInfoTable() {
  return (
    <div style={{ height: 400, width: 1000 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
      />
    </div>
  );
}
